import { deliveryChargeTypeName } from '@/constants/storeManagement/deliveryChargeDialog';
import { AbsDeliveryCharge } from './AbsDeliveryCharge';
export class DeliveryChargePut extends AbsDeliveryCharge {
    storeId = '';
    constructor(data) {
        super(data);
        Object.assign(this, {
            storeId: data.storeId,
        });
    }
    createReqBody() {
        if (this.reqBody.type === deliveryChargeTypeName.DISTANCE) {
            return this.distance();
        }
        if (this.reqBody.type === deliveryChargeTypeName.LOT_NUMBER_ADDRESS) {
            return this.lotNumberAddress();
        }
        return this.area();
    }
    // 거리
    distance() {
        return {
            type: deliveryChargeTypeName.DISTANCE,
            specialArea: this.reqBody.specialArea,
            businessHourStart: this.reqBody.businessHourStart,
            businessHourEnd: this.reqBody.businessHourEnd,
            workingDay: this.reqBody.workingDay,
            charge: this.reqBody.charge,
            surcharge: this.reqBody.surcharge,
            distanceStart: this.reqBody.distanceStart,
            distanceEnd: this.reqBody.distanceEnd,
        };
    }
    // 번지
    lotNumberAddress() {
        return {
            type: deliveryChargeTypeName.LOT_NUMBER_ADDRESS,
            specialArea: this.reqBody.specialArea,
            businessHourStart: this.reqBody.businessHourStart,
            businessHourEnd: this.reqBody.businessHourEnd,
            workingDay: this.reqBody.workingDay,
            charge: this.reqBody.charge,
            surcharge: this.reqBody.surcharge,
            addressJibunEnd: this.reqBody.addressJibunEnd,
            addressJibunStart: this.reqBody.addressJibunStart,
        };
    }
    // 구역
    area() {
        return {
            type: deliveryChargeTypeName.AREA,
            specialArea: this.reqBody.specialArea,
            businessHourStart: this.reqBody.businessHourStart,
            businessHourEnd: this.reqBody.businessHourEnd,
            workingDay: this.reqBody.workingDay,
            charge: this.reqBody.charge,
            surcharge: this.reqBody.surcharge,
            areaId: this.reqBody.areaId,
        };
    }
}
